/**
 * ============================================================================
 * File: themes/generatepress-child/src/card-grid/frontend.js
 * ----------------------------------------------------------------------------
 * Frontend-Logik des Card-Grid-Blocks
 * ============================================================================
 */

function updateCardGrids() {

    document.querySelectorAll('.gb-card-grid').forEach(grid => {

        /* Mehrfaches Nachladen verhindern */

        if (grid.dataset.loading === '1') {
            return;
        }

        /* Anzahl Grid-Spalten */

        const styles = window.getComputedStyle(grid);
        const columns = styles
            .getPropertyValue('grid-template-columns')
            .split(' ')
            .length;

        /* Beitragsdaten */

        const startAnzahl = parseInt(grid.dataset.anzahlBeitraege, 10);
        const aktuellGeladen = grid.querySelectorAll('.gb-card').length;
        const gefunden = parseInt(grid.dataset.gefundeneBeitraege, 10);
        const postType = grid.dataset.postType;

        /* Erste Ausführung */

        const basisAnzahl = aktuellGeladen || startAnzahl;

        /* Fehlende Karten berechnen */

        const zeilen = Math.ceil(basisAnzahl / columns);
        const soll = zeilen * columns;
        const fehlend = Math.max(0, soll - basisAnzahl);

        /* Tatsächlich nachzuladende Beiträge */

        const verfuegbareBeitraege = Math.max(0, gefunden - basisAnzahl);
        const anzahlNachzuladenderBeitraege = Math.min(
            fehlend,
            verfuegbareBeitraege
        );

        if (anzahlNachzuladenderBeitraege === 0) {
            return;
        }

        /* Beiträge nachladen */

        grid.dataset.loading = '1';

        fetch('/wp-admin/admin-ajax.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams({
                action: 'gb_card_grid_load',
                post_type: postType,
                offset: basisAnzahl,
                anzahl: anzahlNachzuladenderBeitraege
            })
        })
        .then(response => response.json())
        .then(data => {

            delete grid.dataset.loading;

            if (!data.success) {
                return;
            }

            grid.insertAdjacentHTML(
                'beforeend',
                data.data.html
            );

        })
        .catch(error => {

            delete grid.dataset.loading;
            console.error(error);

        });

    });

}

/* Erste Berechnung nach dem Laden der Seite */

document.addEventListener('DOMContentLoaded', () => {

    updateCardGrids();

    /* Grid nur neu berechnen, wenn sich das Ausgabegerät ändert */

    OutputDevice.onChange(() => {

        updateCardGrids();

    });


    

});